module.exports = __webpack_public_path__ + "img/screwdriver-wrench-solid.fc289be6.svg";